import React from 'react';

export const GametypeWave = () => (
  <svg
    viewBox='0 0 384 155'
    preserveAspectRatio='none'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <rect x='0.5' y='0.5' width='383' height='154' rx='5.5' stroke='black' strokeOpacity='0.1' />
    <path
      opacity='0.1'
      d='M0 67.8226C57.6 -18.9467 115.2 132.899 192 46.1303C268.8 -40.639 326.4 89.5149 384 13.5918V154.592H0V67.8226Z'
      fill='white'
    />
  </svg>
);
